import { useDeskTheme } from "../../js/hooks/useDeskTheme";

export default function DeskThemeToggle() {
  const ctx = useDeskTheme();
  if (!ctx) return null;
  const { deskTheme, setDeskTheme } = ctx;

  return (
    <div className="desk-theme" role="group" aria-label="Light or dark appearance">
      <button
        type="button"
        className={`desk-theme__btn${deskTheme === "light" ? " is-active" : ""}`}
        aria-pressed={deskTheme === "light"}
        onClick={() => setDeskTheme("light")}
      >
        Light
      </button>
      <button
        type="button"
        className={`desk-theme__btn${deskTheme === "dark" ? " is-active" : ""}`}
        aria-pressed={deskTheme === "dark"}
        onClick={() => setDeskTheme("dark")}
      >
        Dark
      </button>
    </div>
  );
}
